import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "../overview.md"
      }}>{`@add-on-hlapi-sdk`}</a>{` / Context`}</p>
    <h1 {...{
      "id": "class-context"
    }}>{`Class: Context`}</h1>
    <p>{`Contains the user's current selection state, indicating the content they are focused on.`}</p>
    <h2 {...{
      "id": "hierarchy"
    }}>{`Hierarchy`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`ProxyLiveObject`}</inlineCode></p>
        <p parentName="li">{`↳ `}<strong parentName="p"><inlineCode parentName="strong">{`Context`}</inlineCode></strong></p>
      </li>
    </ul>
    <h2 {...{
      "id": "table-of-contents"
    }}>{`Table of contents`}</h2>
    <h3 {...{
      "id": "accessors"
    }}>{`Accessors`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Context.md#hasSelection"
        }}>{`hasSelection`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Context.md#insertionParent"
        }}>{`insertionParent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Context.md#selection"
        }}>{`selection`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Context.md#selectionIncludingNonEditable"
        }}>{`selectionIncludingNonEditable`}</a></li>
    </ul>
    <h2 {...{
      "id": "accessors-1"
    }}>{`Accessors`}</h2>
    <h3 {...{
      "id": "a-idhasselection-namehasselectiona-hasselection"
    }}><a id="hasSelection" name="hasSelection"></a>{` hasSelection`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`hasSelection`}</strong>{`(): `}<inlineCode parentName="p">{`boolean`}</inlineCode></p>
    <h4 {...{
      "id": "returns"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`boolean`}</inlineCode></p>
    <p>{`false if the current editable selection does not contain any nodes, otherwise true.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idinsertionparent-nameinsertionparenta-insertionparent"
    }}><a id="insertionParent" name="insertionParent"></a>{` insertionParent`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`insertionParent`}</strong>{`(): `}<a parentName="p" {...{
        "href": "ContainerNode.md"
      }}><inlineCode parentName="a">{`ContainerNode`}</inlineCode></a></p>
    <h4 {...{
      "id": "returns-1"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "ContainerNode.md"
      }}><inlineCode parentName="a">{`ContainerNode`}</inlineCode></a></p>
    <p>{`the preferred parent to insert newly added content into.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idselection-nameselectiona-selection"
    }}><a id="selection" name="selection"></a>{` selection`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`selection`}</strong>{`(): readonly `}<a parentName="p" {...{
        "href": "Node.md"
      }}><inlineCode parentName="a">{`Node`}</inlineCode></a>{`[]`}</p>
    <h4 {...{
      "id": "returns-2"
    }}>{`Returns`}</h4>
    <p>{`readonly `}<a parentName="p" {...{
        "href": "Node.md"
      }}><inlineCode parentName="a">{`Node`}</inlineCode></a>{`[]`}</p>
    <p>{`the current selection. Nodes that are locked or otherwise non-editable are never included in the selection.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idselectionincludingnoneditable-nameselectionincludingnoneditablea-selectionincludingnoneditable"
    }}><a id="selectionIncludingNonEditable" name="selectionIncludingNonEditable"></a>{` selectionIncludingNonEditable`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`selectionIncludingNonEditable`}</strong>{`(): readonly `}<a parentName="p" {...{
        "href": "Node.md"
      }}><inlineCode parentName="a">{`Node`}</inlineCode></a>{`[]`}</p>
    <h4 {...{
      "id": "returns-3"
    }}>{`Returns`}</h4>
    <p>{`readonly `}<a parentName="p" {...{
        "href": "Node.md"
      }}><inlineCode parentName="a">{`Node`}</inlineCode></a>{`[]`}</p>
    <p>{`the current selection `}<em parentName="p">{`and`}</em>{` any locked nodes the user has attempted to select at the same time. This can
happen for example if the user clicks on a locked node or if the user drags a selection marquee that overlaps
locked nodes in addition to regular unlocked nodes.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      